module.exports = __webpack_public_path__ + "img/battery_3green.90c99337.png";